import apiClient from './api';
import {
  DashboardStats,
  DashboardOverviewResponse,
  DashboardAnalyticsResponse,
  DashboardQueryParams,
  AnalysisTrend,
  RiskDistribution,
  TopBrandsCategories,
  SystemMetrics,
  RecentActivity,
} from '../types/api/dashboard';
import { Analysis } from '../types/api/analyses';

export class DashboardService {
  // Dashboard overview
  static async getDashboardOverview(params?: DashboardQueryParams): Promise<DashboardOverviewResponse> {
    const response = await apiClient.get('/dashboard/overview/', { params });
    return response.data;
  }

  // Dashboard statistics
  static async getDashboardStats(params?: DashboardQueryParams): Promise<DashboardStats> {
    const response = await apiClient.get('/dashboard/stats/', { params });
    return response.data;
  }

  // Recent analyses for dashboard
  static async getRecentAnalyses(limit: number = 10): Promise<Analysis[]> {
    const response = await apiClient.get('/dashboard/recent-analyses/', { 
      params: { limit } 
    });
    return response.data;
  }

  // Recent activities
  static async getRecentActivities(limit: number = 20): Promise<RecentActivity[]> {
    const response = await apiClient.get('/dashboard/recent-activities/', { 
      params: { limit } 
    });
    return response.data;
  }

  // Analytics data
  static async getDashboardAnalytics(params?: DashboardQueryParams): Promise<DashboardAnalyticsResponse> {
    const response = await apiClient.get('/dashboard/analytics/', { params });
    return response.data;
  }

  // Trend data
  static async getAnalysisTrends(params?: DashboardQueryParams): Promise<AnalysisTrend> {
    const response = await apiClient.get('/dashboard/trends/', { params });
    return response.data;
  }

  // Risk distribution
  static async getRiskDistribution(params?: DashboardQueryParams): Promise<RiskDistribution> {
    const response = await apiClient.get('/dashboard/risk-distribution/', { params });
    return response.data;
  }

  // Top brands and categories
  static async getTopBrandsCategories(params?: DashboardQueryParams): Promise<TopBrandsCategories> {
    const response = await apiClient.get('/dashboard/top-items/', { params });
    return response.data;
  }

  // System metrics
  static async getSystemMetrics(): Promise<SystemMetrics> {
    const response = await apiClient.get('/dashboard/system-metrics/');
    return response.data;
  }

  // Performance metrics over time
  static async getPerformanceMetrics(params?: DashboardQueryParams): Promise<any> {
    const response = await apiClient.get('/dashboard/performance/', { params });
    return response.data;
  }

  // Export dashboard data
  static async exportDashboardData(format: 'pdf' | 'excel' | 'csv', params?: DashboardQueryParams): Promise<Blob> {
    const response = await apiClient.get('/dashboard/export/', {
      params: { format, ...params },
      responseType: 'blob',
    });
    return response.data;
  }

  // Real-time updates (WebSocket or polling)
  static async getRealtimeUpdates(): Promise<any> {
    const response = await apiClient.get('/dashboard/realtime/');
    return response.data;
  }

  // Configuration and preferences
  static async updateDashboardPreferences(preferences: Record<string, any>): Promise<void> {
    await apiClient.post('/dashboard/preferences/', preferences);
  }

  static async getDashboardPreferences(): Promise<Record<string, any>> {
    const response = await apiClient.get('/dashboard/preferences/');
    return response.data;
  }
}

export default DashboardService;